<div>
  <div class="st-telematics-section">
    <!-- Filters (always visible) - Only on large screens and above -->
    <div class="filters-containers desktop-filters">
      <!-- Desktop: Always visible form -->
      <form
        [formGroup]="telematicsForm"
        (keydown.enter)="$event.preventDefault()"
      >
        <div class="filter-inputs">
          <!--Date of Service-->
          <div class="filter-control">
            <p-datepicker
              (onSelect)="onDateChange($event)"
              formControlName="dateOfService"
              placeholder="Filter by Date"
              [iconDisplay]="'input'"
              [maxDate]="currentDate"
              [showIcon]="true"
              class="w-full"
              appendTo="body"
            >
              <ng-template
                pTemplate="inputicon"
                let-clickCallBack="clickCallBack"
              >
                <i
                  class="pi icon-calendar-dot icon-light-color pointer-events-none pointer-events-none"
                  (click)="clickCallBack($event)"
                  (keydown.enter)="clickCallBack($event)"
                ></i>
              </ng-template>
            </p-datepicker>
          </div>

          <!--Drivers-->
          <div class="filter-control">
            <p-select
              appAdjustDropdownHeight
              id="driverId"
              [options]="driversList"
              optionValue="id"
              optionLabel="fullName"
              formControlName="driverId"
              virtualScroll="true"
              virtualScrollItemSize="36"
              placeholder="Filter by Driver Name"
              (onChange)="getRidesByDriver($event.value)"
              [filter]="true"
              class="w-full"
              appendTo="body"
            />
          </div>

          <!--Ride-->
          <div class="filter-control">
            <p-select
              appAdjustDropdownHeight
              id="rideId"
              [options]="rideList"
              optionValue="id"
              optionLabel="id"
              formControlName="rideId"
              virtualScroll="true"
              virtualScrollItemSize="36"
              placeholder="Filter by Ride ID"
              [filter]="true"
              class="w-full"
              appendTo="body"
            />
          </div>
        </div>

        <!--Search & Clear button-->
        <div class="flex gap-spacing-md desktop-filter-actions">
          <app-button
            label="Clear"
            (btnClick)="Clear()"
            sizeClass="p-button-sm"
            severity="secondary"
            [outlinedButton]="true"
          />
          <app-button
            label="Search"
            (btnClick)="Search()"
            [disabled]="!telematicsForm.valid"
            sizeClass="p-button-sm"
            severity="primary"
          />
        </div>
      </form>
    </div>

    <!-- Mobile and Tablet: Collapsible filters container -->
    <div class="mobile-tablet-filters">
      <!-- Mobile/Tablet header with toggle button -->
      <div class="st-telematics-section-header">
        <div
          class="switcher table-bg-head-bg radius-sm flex align-content-center"
        >
          <button
            type="button"
            class="px-spacing-md py-spacing-default cursor-pointer radius-sm text-center text-caption-color label-large-medium h-36 flex-1 white-space-nowrap"
            [class.active]="currentView === 'map'"
            (click)="setCurrentView('map')"
          >
            <div class="flex gap-spacing-default align-items-center">
              <img
                src="assets/icons/map-switcher.svg"
                alt="Map"
                class="switcher-icon label-large-medium"
              />
              <span class="switcher-text-desktop">Map</span>
              <span class="switcher-text-mobile">Map</span>
            </div>
          </button>
          <button
            type="button"
            class="px-spacing-md py-spacing-default cursor-pointer radius-sm text-center text-caption-color label-large-medium flex-1 white-space-nowrap"
            [class.active]="currentView === 'details'"
            (click)="setCurrentView('details')"
          >
            <div class="flex gap-spacing-default align-items-center">
              <img
                src="assets/icons/detail-switcher.svg"
                alt="Details"
                class="switcher-icon label-large-medium"
              />
              <span class="switcher-text-desktop">Details</span>
              <span class="switcher-text-mobile">Details</span>
            </div>
          </button>
        </div>
        <div class="filter-toggler-sm-screen">
          <app-button
            [label]="showFilters() ? 'Hide Filters' : 'View Filters'"
            iconStart="icon-funnel-simple"
            (btnClick)="toggleFilters()"
            [outlinedButton]="true"
            sizeClass="p-button-sm"
            severity="primary"
          >
          </app-button>
        </div>
      </div>

      <!-- Mobile collapsible filters -->
      <div
        class="filters-containers"
        stCollapsible
        [isCollapsed]="!showFilters()"
        (closed)="formClosed.set($event)"
      >
        <form
          [formGroup]="telematicsForm"
          (keydown.enter)="$event.preventDefault()"
        >
          <div class="filter-inputs">
            <!--Date of Service-->
            <div class="filter-control">
              <p-datepicker
                (onSelect)="onDateChange($event)"
                formControlName="dateOfService"
                placeholder="Filter by Date"
                [iconDisplay]="'input'"
                [maxDate]="currentDate"
                [showIcon]="true"
                class="w-full"
                appendTo="body"
              >
                <ng-template
                  pTemplate="inputicon"
                  let-clickCallBack="clickCallBack"
                >
                  <i
                    class="pi icon-calendar-dot icon-light-color pointer-events-none pointer-events-none"
                    (click)="clickCallBack($event)"
                    (keydown.enter)="clickCallBack($event)"
                  ></i>
                </ng-template>
              </p-datepicker>
            </div>

            <!--Drivers-->
            <div class="filter-control">
              <p-select
                appAdjustDropdownHeight
                id="driverId-mobile"
                [options]="driversList"
                optionValue="id"
                optionLabel="fullName"
                formControlName="driverId"
                virtualScroll="true"
                virtualScrollItemSize="36"
                placeholder="Filter by Driver Name"
                (onChange)="getRidesByDriver($event.value)"
                [filter]="true"
                class="w-full"
                appendTo="body"
              />
            </div>

            <!--Ride-->
            <div class="filter-control">
              <p-select
                appAdjustDropdownHeight
                id="rideId-mobile"
                [options]="rideList"
                optionValue="id"
                optionLabel="id"
                formControlName="rideId"
                virtualScroll="true"
                virtualScrollItemSize="36"
                placeholder="Filter by Ride ID"
                [filter]="true"
                class="w-full"
                appendTo="body"
              />
            </div>
          </div>

          <!--Search & Clear button-->
          <div class="filter-actions flex gap-spacing-md">
            <app-button
              label="Clear"
              (btnClick)="Clear()"
              sizeClass="p-button-sm"
              severity="secondary"
              [outlinedButton]="true"
            />
            <app-button
              label="Search"
              (btnClick)="Search()"
              [disabled]="!telematicsForm.valid"
              sizeClass="p-button-sm"
              severity="primary"
            />
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="card">
    <!-- Desktop: Always show both map and details side by side -->
    <div class="desktop-layout">
      <!-- Map Section: 65% of the screen -->
      <div class="desktop-map-section flex-65">
        @if (!isShow) {
          <app-telematics-section-map
            #TelematicsSectionMap
            [basicRideCoordinateDto]="mapData"
            [markers]="mapMarkers"
            [options]="mapOptions"
          ></app-telematics-section-map>
        }
        @if (isShow) {
          <div>
            <div class="my-google-map">
              <div class="map-container">
                <google-map [options]="defaultMapOptions"></google-map>
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Details Section: 35% of the screen -->
      <div class="desktop-details-section flex-35 background-muted-primary-bg">
        @if (!isShow) {
          <app-telematics-section-details
            [rideDetailsResult]="rideDetailsResult"
          />
        }
        @if (isShow) {
          <div class="h-100 p-spacing-3xl empty-details">
            <div class="text-center">
              <img
                alt="no-map-available"
                src="assets/images/icons/icon-no-map-available.png"
                style="width: 92px; height: 92px"
              />
              <div
                class="text-center body-medium-regular form-border-hover-color pl-spacing-3xl pr-spacing-3xl"
              >
                Please enter Ride ID &amp; click on search to retrieve the
                telematics that are related to that ride.
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Mobile/Tablet: Show either map or details based on currentView -->
    <div class="mobile-tablet-content">
      <!-- Map Section for Mobile/Tablet -->
      @if (currentView === "map") {
        <div>
          @if (!isShow) {
            <app-telematics-section-map
              #TelematicsSectionMapMobile
              [basicRideCoordinateDto]="mapData"
              [markers]="mapMarkers"
              [options]="mapOptions"
            ></app-telematics-section-map>
          }
          @if (isShow) {
            <div>
              <div class="my-google-map">
                <div class="map-container">
                  <google-map [options]="defaultMapOptions"></google-map>
                </div>
              </div>
            </div>
          }
        </div>
      }

      <!-- Details Section for Mobile/Tablet -->
      @if (currentView === "details") {
        <div class="background-muted-primary-bg container-empty-details">
          @if (!isShow) {
            <app-telematics-section-details
              [rideDetailsResult]="rideDetailsResult"
            />
          }
          @if (isShow) {
            <div class="h-100 p-spacing-3xl empty-details">
              <div class="text-center">
                <img
                  alt="no-map-available"
                  src="assets/images/icons/icon-no-map-available.png"
                  style="width: 92px; height: 92px"
                />
                <div
                  class="text-center body-medium-regular text-light-color pl-spacing-3xl pr-spacing-3xl"
                >
                  Please enter Ride ID &amp; click on search to retrieve the
                  telematics that are related to that ride.
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
